import React from 'react';
import { AlertCircle, BatteryWarning, HeartCrack } from 'lucide-react';
export function PainSection() {
  const pains = [{
    icon: <BatteryWarning className="w-8 h-8 text-[#E53E3E]" data-id="element-156" />,
    title: 'Agotamiento Crónico',
    description: 'Sientes que tu batería nunca pasa del 10%, sin importar cuánto duermas.'
  }, {
    icon: <HeartCrack className="w-8 h-8 text-[#E53E3E]" data-id="element-157" />,
    title: 'Culpa Corrosiva',
    description: "El ácido que corroe tu energía cada vez que intentas descansar sin 'merecerlo'."
  }, {
    icon: <AlertCircle className="w-8 h-8 text-[#E53E3E]" data-id="element-158" />,
    title: 'Parálisis por Análisis',
    description: 'Tantas cosas por hacer que terminas no haciendo ninguna, y odiándote por ello.'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-159">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-162">
            Por qué duele tanto "no hacer nada"
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-163">
            La culpa es el verdadero enemigo. Crea un agujero negro que te
            absorbe más y más profundo.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-164">
          {pains.map((pain, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-[#E53E3E] hover:shadow-lg transition-shadow" data-id="element-165">
              <div className="bg-red-50 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-166">
                {pain.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3 text-center" data-id="element-167">
                {pain.title}
              </h3>
              <p className="text-slate-600 text-center leading-relaxed" data-id="element-168">
                {pain.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}